// Module
var code = "<div ng-class=\"{'edited': $ctrl.type === 'Edited'}\" class=\"br-caption-2\"> {{$ctrl.type | translate}} </div> ";
// Exports
export default code;